import React from 'react'
import { CodeName, InlineIconShortcodeName } from './types'
import { GGOImproveIcon } from './icons/ggo-improve-icon'

interface InlineIconShortcodeProps {
  codeName: InlineIconShortcodeName
}

export const InlineIconCodeName: React.FC<InlineIconShortcodeProps> = (props) => {
  switch (props.codeName) {
    case CodeName.GGOImproveIcon:
      return <GGOImproveIcon />
  }

  return null
}
